// tableColumns.js
import React from 'react';
import { Badge, Space } from 'antd';
import { PaperClipOutlined, EyeOutlined, DownloadOutlined, MailOutlined, FormOutlined } from '@ant-design/icons';
import { TableActions } from '~/components/Table';
import { Button } from 'antd';
import moment from 'moment';

/**
 * Returns the column definitions for the invoice table.
 *
 * @param {Object} params
 * @param {Function} params.t - Translation function.
 * @param {Object} params.style - Style object for custom styles.
 * @param {Function} params.showFile - Function to show the file.
 * @param {Function} params.handleDownload - Function to handle download.
 * @param {Function} params.handleSendInvoice - Function to handle sending invoice.
 * @param {Function} params.onAttachClick - Function to handle attach click.
 * @param {Function} params.onLienClick - Function to show lien waiver.
 * @returns {Array} Array of column definitions for the invoice table.
 */

export function getInvoiceColumns({
  t,
  style,
  showFile,
  handleDownload,
  handleSendInvoice,
  onAttachClick,
  onLienClick,
}) {

  return [
    {
      title: t('screens:invoices.data.id'),
      dataIndex: 'id',
      key: 'id',
      align: 'center',
      width: 50,
      ellipsis: { showTitle: true },
    },
    {
      title: t('screens:invoices.data.date'),
      dataIndex: 'date',
      key: 'date',
      render: date => (date ? moment(date).format('YYYY/MM/DD') : <>N/A</>),
    },
    {
      title: t('screens:workbook.receipts.data.paymentDate'),
      dataIndex: 'paymentDate',
      key: 'paymentDate',
      align: 'center',
      ellipsis: { showTitle: false },
      render: paymentDate => (paymentDate ? moment(paymentDate).format('MM/DD/YYYY') : <>N/A</>),
    },
    {
      title: t('screens:workbook.receipts.data.status'),
      dataIndex: 'paymentDate',
      key: 'statusBadge',
      align: 'center',
      width: 120,
      render: (_text, record) =>
        record.paymentDate !== null ? (
          <Badge count={t('screens:workbook.receipts.data.paid')} style={style.paid} title="PAID" />
        ) : (
          <Badge count={t('screens:workbook.receipts.data.noPaid')} style={style.noPaid} title="NO PAID" />
        ),
    },
    {
      title: t('screens:invoices.data.actions'),
      key: 'actions',
      align: 'center',
      width: 180,
      render: record => (
        <TableActions>
          <Space direction="horizontal" size="small">
            <Button
              style={style.btn}
              type="link"
              title={t('screens:invoices.data.attachFile')}
              onClick={() => onAttachClick(record)}
            >
              <PaperClipOutlined />
            </Button>
            <Button style={style.btn} type="link" title={t('messages:view')} onClick={() => showFile(record)}>
              <EyeOutlined />
            </Button>
            <Button style={style.btn} type="link" title={t('messages:download')} onClick={() => handleDownload(record)}>
              <DownloadOutlined />
            </Button>
            <Button
              style={style.btn}
              type="link"
              title={t('screens:invoices.btnSendCustomer')}
              onClick={() => handleSendInvoice(record.id)}
            >
              <MailOutlined />
            </Button>
            {/* <Button
            style={style.btn}
            type="link" 
            title="Lien Waiver"
            onClick={() => onLienClick(record)}
          >
            <FormOutlined />
          </Button> */}
            {record.lienWaiver && record.lienWaiver !== '' && record.lienWaiver !== null && (
              <Button style={style.btn} type="link" title="Lien Waiver" onClick={() => onLienClick(record)}>
                <FormOutlined />
              </Button>
            )}
          </Space>
        </TableActions>
      ),
    },
  ];
}
